import {
  PAYMODE as _PAYMODE,
  TOKEN as _TOKEN,
  FLOW as _FLOW,
  EMI_SUBVENTION_STRATEGY as _EMI_SUBVENTION_STRATEGY,
  ELEMENT_PAYMODE as _ELEMENT_PAYMODE
} from './src/constant';
import { API as _API } from './src/api';

/**
 * Promise polyfill if browser not supported
 * */

if (!window.Promise) {
  if (STATIC_HOST) {
    const s = document.createElement('script');
    s.type = 'application/javascript';
    s.async = true;
    s.src = `${STATIC_HOST}/common/lib/promise/promise-polyfill.min.js`;
    document.body.appendChild(s);
  }
}

export const API = _API;
export const TOKEN = _TOKEN;
export const PAYMODE = _PAYMODE;
export const FLOW = _FLOW;
export const ELEMENT_PAYMODE = _ELEMENT_PAYMODE;
export const EMI_SUBVENTION_STRATEGY = _EMI_SUBVENTION_STRATEGY;



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/index.api.js